import {useCallback} from 'react';
import * as CandidatesApi from '../api';

const useCandidateDuplicateDetection = () => {
  const checkForDuplicates = useCallback(async candidateId => {
    if (!candidateId) return null;

    try {
      const response = await CandidatesApi.getPossibleDuplicates(candidateId);
      return response.data;
    } catch (error) {
      console.error('Error checking for duplicates:', error);
      throw error;
    }
  }, []);

  return checkForDuplicates;
};

export default useCandidateDuplicateDetection;
